import checkResponse from "../helpers/responseService"

export default {
  getActiveAccountManagers() {
    return axios.get('/account-managers/list')
      .then(response => checkResponse(response))
  },
}



// WEBPACK FOOTER //
// ./resources/js/services/accountManagersDataService.js